<ng-container *ngIf="data?.success">
	<h3 class="title-main margin-sm-10" dcrHTMLKey="SNAPSHOT_TITLE">Snapshot</h3>
	<section class="portfolio-snapshot-section">
		<!-- When you have tabs like Common period, 1 year, 3 year -->
		<div class="row fee-only-row" [class.proposal-enabled]="hasProposalMetrics">
			<ng-container *ngTemplateOutlet="feeBenchmarkSelection"></ng-container>
		</div>

		<div *showOnlyInView="[ViewCategory.PROPOSAL]">
			<ng-container *ngIf="hasProposalMetrics">
				<accordion-panel [isCollapsed]="isProposalMetricsSectionCollapsed" (onToggleChange)="onProposalAccordionClicked()">
					<header>
						<div class="proposal-metrics-section-title" dcrHTMLKey="PROPOSAL_HOW">How I got you there:</div>
					</header>
					<content>
						<proposal-metrics></proposal-metrics>
					</content>
				</accordion-panel>
			</ng-container>
		</div>

		<!-- When you dont have tabs like Common period, 1 year, 3 year -->
		<div class="row d-flex align-items-center margin-top-20" *ngIf="data?.tabs?.length === 1">
			<div class="col-12" [class.col-24]="!isCustomFeeEnabled">
				<ac-cta-link (click)="isCommonPeriodModalVisible = true" icon="arrow-right" class="text-16-bold" *ngIf="!hideCommonPeriod">
					<span dcrHTMLKey="DEFINING_COMMON_PERIOD"> What is defining the common period? </span>
				</ac-cta-link>
			</div>
		</div>

		<ng-container *ngIf="data?.tabs?.length > 1; else singleItem">
			<bfa-tabs type="underline" custom-classes="snapshot-overview">
				<ng-container *ngFor="let tab of data.tabs; let tabIndex = index">
					<ng-template #tabItem>
						<ng-container *ngIf="tabIndex === 0 && !hideCommonPeriod">
							<p class="text-16">
								{{ cellUtils.getFormattedCellValueById(tab.tableData[0].cells[0], snapshotDataIds.AS_OF_DATE_START) }} -
								{{ cellUtils.getFormattedCellValueById(tab.tableData[0].cells[0], snapshotDataIds.AS_OF_DATE_END) }}
							</p>
							<p dcrHTMLKey="PORTFOLIO_SNAPSHOT_SUB_HEADER" class="text-16">
								The historical period for which returns are available for all holdings. The common period begins at the inception date of the newest fund or share
								class.
							</p>
						</ng-container>
						<ac-cta-link
							(click)="isCommonPeriodModalVisible = true"
							icon="arrow-right"
							class="margin-bottom-20 text-16-bold"
							*ngIf="tabIndex === 0 && !hideCommonPeriod"
						>
							<span dcrHTMLKey="DEFINING_COMMON_PERIOD"> What is defining the common period? </span>
						</ac-cta-link>
						<ng-container *ngTemplateOutlet="tableDisplayItem; context: { tab: tab, tabIndex: tabIndex }"></ng-container>
					</ng-template>
					<tab-panel [tab-title]="tab.config.title.label" [templateRef]="tabItem"></tab-panel>
				</ng-container>
			</bfa-tabs>
		</ng-container>
		<ng-template #singleItem>
			<ng-container *ngIf="data">
				<ng-container *ngTemplateOutlet="tableDisplayItem; context: { tab: data.tabs[0], tabIndex: 0 }"></ng-container>
			</ng-container>
		</ng-template>
		<ac-disclosure>
			<ac-tpm-disclosure [isSnapshot]="true"></ac-tpm-disclosure>
			<span *ngIf="!isCustomFeeEnabled && !displayISOCurrency" dcrHTMLKey="SNAPSHOT_DISCLOSURE">SNAPSHOT_DISCLOSURE</span>
			<section *ngIf="isCustomFeeEnabled && (!customAdvisoryFee || !isNetPerformanceValid)">
				<span dcrHTMLKey="NO_NET_PERF_DISCLOSURE">NO_NET_PERF_DISCLOSURE</span>
			</section>
			<span *ngIf="isCustomFeeEnabled" dcrHTMLKey="SNAPSHOT_DISCLOSURE_NET">SNAPSHOT_DISCLOSURE_NET</span>
			<section dcrHTMLKey="PERFORMANCE_DISCLOSURE_TEXT" data-cy="holdings-analytics-performance-disclosure">PERFORMANCE DISCLOSURE</section>
			<section dcrHTMLKey="PERFORMANCE_SOURCE">Source: Morningstar, Refinitive and BlackRock Aladdin</section>
			<section dcrHTMLKey="PERFORMANCE_POST_DISCLOSURE_TEXT" [dcrSubstitutions]="{ $currency$: displayISOCurrency }" data-cy="holdings-analytics-disclosure-currency">
				Currency: $currency$, performance is net of fees
			</section>
		</ac-disclosure>
		<section class="section-separator"></section>
	</section>
</ng-container>

<bfa-modal width="750px" [enableBackdrop]="true" [enableClose]="true" [isVisible]="showRiskInfoBubbleModal" (isVisibleChange)="showRiskInfoBubbleModal = false">
	<section class="modal-message-container" [innerHTML]="riskInfoBubbleText"></section>
</bfa-modal>

<ng-template #feeBenchmarkSelection>
	<div class="col-12" *ngIf="isCustomFeeEnabled" [class.col-24]="!hasBenchmarkPortfolio">
		<div>
			<cfe-custom-advisory-fee-dialog-button id="pa-custom-fee-dialog" [customAdvisoryFee]="customAdvisoryFee"></cfe-custom-advisory-fee-dialog-button>
		</div>
	</div>
	<div class="col-12 ac-dropdown custom-dropdown" *ngIf="hasBenchmarkPortfolio">
		<div class="capture-ratio-vs" dcrHTMLKey="CAPTURE_RATIO_VS">Capture Ratio vs</div>
		<select (change)="onBenchmarkOptionChange()" [(ngModel)]="selectedBenchmarkForCaptureRatio">
			<option *ngFor="let benchmarkOption of benchmarkOptions | keyvalue" [value]="benchmarkOption?.value">
				{{ benchmarkOption?.value | dcr : 'CAPTURE_RATIO_OPTION_' + (benchmarkOption?.key | uppercase) }}
			</option>
		</select>
	</div>
</ng-template>

<ng-template #tableDisplayItem let-tab="tab" let-tabIndex="tabIndex">
	<div class="row portfolio-snapshot" [ngClass]="{ 'multi-portfolios': hasMultiPortfolios, 'single-portfolio': !hasMultiPortfolios }">
		<!--PERFORMANCE-->
		<section class="analysis-item performance-item" [ngClass]="analysisSectionClass" *ngIf="!tab.error">
			<div class="section-container">
				<!-- Header -->
				<ng-container *ngTemplateOutlet="header; context: { header: { dcrKey: 'PERFORMANCE_HEADER', icon: 'Performance', defaultValue: 'Performance' } }"></ng-container>
				<div *ngFor="let column of performanceColumns">
					<div *ngIf="column.children; else singleView">
						<ng-container
							*ngTemplateOutlet="
								partnerSectionElement;
								context: {
									section: {
										column: column,
										tab: tab,
										asOfDate: asOfDates && asOfDates[0].asOfDatePerformance ? asOfDates[0].asOfDatePerformance : null
									}
								}
							"
						></ng-container>
					</div>
					<ng-template #singleView>
						<ng-container
							*ngTemplateOutlet="
								sectionElement;
								context: {
									section: {
										id: column,
										tab: tab,
										asOfDate:
											asOfDates && asOfDates[0][performanceColumnsAsOfDateMapping[column]] ? asOfDates[0][performanceColumnsAsOfDateMapping[column]] : null
									}
								}
							"
						></ng-container>
					</ng-template>
				</div>
			</div>
		</section>

		<!-- RISK AND COST -->
		<section class="no-padding" [ngClass]="riskAndCostSectionClass">
			<div class="row col-24 col-sm-24 no-padding no-margin full-height">
				<!--RISK-->
				<section class="analysis-item" [ngClass]="riskAndCostIndividualClass" *ngIf="!tab.error">
					<div class="section-container">
						<!-- Header -->
						<ng-container *ngTemplateOutlet="header; context: { header: { dcrKey: 'RISK_HEADER', icon: 'Risk', defaultValue: 'Risk' } }"></ng-container>

						<div *ngFor="let riskColumn of riskColumns">
							<ng-container
								*ngTemplateOutlet="
									sectionElement;
									context: {
										section: {
											id: riskColumn.columnId,
											tab: tab,
											asOfDate: asOfDates && asOfDates[0][riskColumn.asOfDateId] ? asOfDates[0][riskColumn.asOfDateId] : null
										}
									}
								"
							></ng-container>
						</div>
					</div>
				</section>

				<!--COST-->
				<section class="analysis-item" [ngClass]="riskAndCostIndividualClass" *ngIf="!tab.error && !hideCost">
					<div class="section-container">
						<!-- Header -->
						<ng-container *ngTemplateOutlet="header; context: { header: { dcrKey: 'COST_HEADER', icon: 'Cost', defaultValue: 'Cost' } }"></ng-container>

						<div *ngFor="let costId of costColumns">
							<ng-container
								*ngTemplateOutlet="
									sectionElement;
									context: {
										section: {
											id: costId,
											tab: tab,
											asOfDate: asOfDates && asOfDates[0].asOfDateCost ? asOfDates[0].asOfDateCost : null
										}
									}
								"
							></ng-container>
						</div>
					</div>
				</section>
			</div>
		</section>
	</div>
</ng-template>

<!-- partner section -->
<ng-template #partnerSectionElement let-section="section">
	<div
		[class.row]="hasMultiPortfolios"
		class="category-section category-item text-14"
		*ngIf="cellUtils.isCellVisible(cellUtils.getById(section.tab.tableData[0].cells[0], section.column.children[0]))"
	>
		<!-- sub category -->
		<ng-container
			*ngTemplateOutlet="
				subCategory;
				context: {
					info: {
						subCategoryItem: performanceTitleCells[section.column.sectionKey],
						asOfDateItem: section.asOfDate
					}
				}
			"
		></ng-container>
		<ul class="category-item">
			<li class="text-14" *ngFor="let id of section.column.children">
				<ng-container
					*ngTemplateOutlet="
						sectionElement;
						context: {
							section: {
								id: id,
								tab: section.tab,
								asOfDate: null
							}
						}
					"
				></ng-container>
			</li>
		</ul>
	</div>
</ng-template>

<!-- column section -->
<ng-template #sectionElement let-section="section">
	<div class="category-wrapper text-14" [class.row]="hasMultiPortfolios" *ngIf="cellUtils.isCellVisible(cellUtils.getById(section.tab.tableData[0].cells[0], section.id))">
		<!-- sub category -->
		<ng-container
			*ngTemplateOutlet="
				subCategory;
				context: {
					info: {
						subCategoryItem: cellUtils.getById(section.tab.tableData[0].cells[0], section.id),
						asOfDateItem: section.asOfDate
					}
				}
			"
		></ng-container>
		<div class="data-item text-align-right" [ngClass]="dataContainerClass">
			<ng-container *ngFor="let portfolio of data.tabs[0].tableData[0].headersY; let portfolioIndex = index">
				<!-- data -->
				<ng-container
					*ngTemplateOutlet="
						dataValues;
						context: {
							dataValues: {
								tab: section.tab,
								cellIndex: cellUtils.getIndex(section.tab.tableData[0].cells[0], section.id),
								portfolioIndex: portfolioIndex
							}
						}
					"
				></ng-container>
			</ng-container>
			<ng-container *emptyPortfolio="portfolioIds">
				<span class="text-14 color-secondary" [ngClass]="dataItemClass" attr.data-cy="holdings-analytics-column-section-data-{{ portfolioIndex }}">
					<!-- Empty span to add space for empty portfolio -->
				</span>
			</ng-container>
		</div>
	</div>
</ng-template>

<!-- Sub Category template-->
<ng-template #subCategory let-snapshotData="info">
	<div class="category-item text-14" [ngClass]="categoryContainerClass" *ngIf="snapshotData.subCategoryItem">
		<p>
			<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
			<span
				class="icon-caption"
				*ngIf="snapshotData.subCategoryItem?.config?.label"
				[dcrHTMLKey]="snapshotData.subCategoryItem?.config?.label?.key"
				[innerHtml]="replacePlaceholders(snapshotData.subCategoryItem.config.label)"
			></span>
			<span class="icon-caption" *ngIf="snapshotData.subCategoryItem?.attribute?.optionalLabel" [innerHtml]="snapshotData.subCategoryItem?.attribute?.optionalLabel"></span>
			<dcr-cell-content [cell]="snapshotData.subCategoryItem"></dcr-cell-content>
			<ng-container *ngIf="snapshotData.subCategoryItem?.config?.infoBubble">
				<icon
					type="info-circle"
					class="info-circle"
					*ngIf="!snapshotData.useModal"
					[tooltip]="infoBubble"
					[analytic-data]="{ linkName: 'tooltip_' + snapshotData.subCategoryItem?.config?.label?.key }"
				>
				</icon>
				<icon
					type="info-circle"
					class="info-circle pointer"
					*ngIf="snapshotData.useModal"
					(click)="toggleInfoDialog(replacePlaceholders(snapshotData.subCategoryItem?.config?.label), snapshotData.tabIndex)"
				>
				</icon>
			</ng-container>
			<ng-template #infoBubble>
				<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
				<section [innerHTML]="replacePlaceholders(snapshotData.subCategoryItem?.config?.infoBubble)"></section>
			</ng-template>
		</p>
		<p *ngIf="snapshotData.asOfDateItem" class="date text-14 date-item">
			<span dcrHTMLKey="AS_OF_DATE">As of</span><span> {{ snapshotData.asOfDateItem }}</span>
		</p>
	</div>
</ng-template>

<!--Header template-->
<ng-template #header let-header="header">
	<div class="header-item">
		<img ada-decorative [remote-src]="header.icon + '.svg'" class="item-icon text-20" />
		<h3 class="title-sub text-uppercase" [dcrHTMLKey]="header.dcrKey" [innerHTML]="header.defaultValue"></h3>
	</div>
</ng-template>

<!--Data template-->
<ng-template #dataValues let-dataValues="dataValues">
	<ng-container *ngIf="dataValues.tab && dataValues.cellIndex > -1">
		<span
			*ngIf="dataValues.tab.tableData[0].cells[dataValues.portfolioIndex][dataValues.cellIndex].formattedValue; else notApplicable"
			class="text-14 color-secondary"
			[ngClass]="dataItemClass"
			[innerHTML]="dataValues.tab.tableData[0].cells[dataValues.portfolioIndex][dataValues.cellIndex].formattedValue"
			attr.data-cy="holdings-analytics-column-section-data-{{ dataValues.portfolioIndex }}-{{ dataValues.cellIndex }}"
		>
		</span>
		<ng-template #notApplicable> <span class="not-applicable" [ngClass]="dataItemClass">n/a</span> </ng-template>
	</ng-container>
</ng-template>

<bfa-modal [(isVisible)]="isCommonPeriodModalVisible" [enableClose]="true" [enableBackdrop]="true" width="980px">
	<ng-template [componentId]="'performance.common.period'" let-data [loading]="emptyTemplate">
		<perf-common-period *componentId="'performance.common.period'; let res" [data]="res"></perf-common-period>
	</ng-template>
</bfa-modal>
<ng-template #emptyTemplate></ng-template>
